import { render } from "./LoginFormBootstrap.vue?vue&type=template&id=073cded4&scoped=true"
import script from "./LoginFormBootstrap.vue?vue&type=script&lang=js"
export * from "./LoginFormBootstrap.vue?vue&type=script&lang=js"

import "./LoginFormBootstrap.vue?vue&type=style&index=0&id=073cded4&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\PeD\\ApontaFacil\\dashboard\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073cded4"]])

export default __exports__